export const SET_APP_NAME = "SET_APP_NAME"; //eslint-disable-line
export type SET_APP_NAME = typeof SET_APP_NAME; //eslint-disable-line
export const SET_ACTIVE_ITEM_INDEX = "SET_ACTIVE_ITEM_INDEX"; //eslint-disable-line
export type SET_ACTIVE_ITEM_INDEX = typeof SET_ACTIVE_ITEM_INDEX; //eslint-disable-line
